<div class="key-value-container" fxLayout="row" [fxLayoutAlign]="alignment" style="width:100%;" fxLayoutGap="10px">
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" fxFlex="{{keyWidthPercent + '%'}}"
       [ngStyle]="{'min-width': keyWidthPercent + '%'}">
    <strong class="color-muted">{{key}}</strong>
    <div fxFlex></div>
    <mtn-what-is-this [text]="whatIsThisText" *ngIf="whatIsThisText"></mtn-what-is-this>
  </div>
  <ng-content fxFlex></ng-content>
</div>
